var _ellipse, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEva(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 42.8,
    rx: 12.8,
    ry: 1.2,
    fill: "url(#eva_svg__paint0_radial)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eva_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.647.095a.717.717 0 00-.977.262.717.717 0 00-.978-.262.717.717 0 00-.261.977l.474.822c.158.273.471.4.765.34a.715.715 0 00.764-.34l.475-.822a.717.717 0 00-.262-.977z",
    fill: "#EBC21C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.012 18.594c-.553.893-.765 1.36-.765 1.36s-1.232-.043-1.7.17c-.467.213-.722.82-.297 1.175.425.355.765.405.765.405s-.51 1.65 0 3.137 1.402 1.784 2.167 1.784c.765 0 1.317-.17 2.21-1.784.892-1.615 1.19-3.542 1.19-3.542l-1.7-4.853s-1.318 1.256-1.87 2.148zM36.792 20.123c-.467-.212-1.7-.17-1.7-.17s-.212-.467-.764-1.36c-.553-.892-1.87-2.148-1.87-2.148l-1.7 4.853s.298 1.927 1.19 3.542c.892 1.614 1.445 1.784 2.21 1.784.764 0 1.657-.297 2.167-1.784.51-1.488 0-3.137 0-3.137s.34-.05.765-.405c.425-.354.17-.962-.298-1.175z",
    fill: "#6B8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.095 8.015a3.187 3.187 0 100-6.374 3.187 3.187 0 000 6.374z",
    fill: "#EBC21C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.095 6.21a1.383 1.383 0 100-2.765 1.383 1.383 0 000 2.766z",
    fill: "#6B8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.095 3.445a1.383 1.383 0 110 2.766 1.383 1.383 0 010-2.766zm0-.637c-1.114 0-2.02.906-2.02 2.02 0 1.114.906 2.02 2.02 2.02 1.114 0 2.02-.906 2.02-2.02 0-1.114-.906-2.02-2.02-2.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.005 8.015a3.187 3.187 0 100-6.374 3.187 3.187 0 000 6.374z",
    fill: "#EBC21C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.006 6.21a1.383 1.383 0 100-2.765 1.383 1.383 0 000 2.766z",
    fill: "#6B8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.006 3.445a1.383 1.383 0 110 2.766 1.383 1.383 0 010-2.766zm0-.637c-1.114 0-2.02.906-2.02 2.02 0 1.114.906 2.02 2.02 2.02 1.114 0 2.02-.906 2.02-2.02 0-1.114-.906-2.02-2.02-2.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.171 15.067c0-7.401-6.206-13.63-13.607-13.63-7.402 0-13.402 6-13.402 13.402 0 .763.238 5.88 2.566 11.84 2.182 5.586 6.383 10.453 7.95 11.664 1.35 1.042 1.992 1.517 2.779 1.63.021.016.042.027.06.027.058 0 .114-.002.169-.005.055.003.11.005.168.005.019 0 .04-.011.06-.028.787-.112 1.43-.587 2.779-1.63 1.567-1.21 5.607-6.143 7.95-11.663 2.783-6.555 2.528-11.174 2.528-11.612z",
    fill: "#EC9E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.664 12.836c0-4.588-4.1-8.307-9.157-8.307-5.058 0-9.157 3.72-9.157 8.307 0 3.304 2.125 6.157 5.204 7.495-.039.21-.063.423-.063.643 0 2.088 1.808 3.782 4.037 3.782 2.23 0 4.037-1.694 4.037-3.782 0-.226-.025-.445-.065-.66 3.056-1.346 5.164-4.188 5.164-7.478z",
    fill: "#6B8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.507 4.529c5.057 0 9.157 3.72 9.157 8.307 0 3.29-2.108 6.132-5.164 7.478.04.215.065.434.065.66 0 2.088-1.807 3.782-4.037 3.782s-4.037-1.694-4.037-3.782c0-.22.024-.433.063-.643-3.079-1.338-5.204-4.191-5.204-7.495 0-4.588 4.1-8.307 9.157-8.307zm0-.638c-5.4 0-9.795 4.013-9.795 8.945 0 3.283 2.007 6.327 5.151 7.877-.006.088-.01.175-.01.26 0 2.438 2.098 4.42 4.675 4.42 2.578 0 4.674-1.983 4.674-4.42 0-.092-.003-.185-.01-.28 3.12-1.556 5.11-4.592 5.11-7.857 0-4.932-4.394-8.945-9.795-8.945z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.685 12.985a1.275 1.275 0 100-2.55 1.275 1.275 0 000 2.55zM25.328 12.985a1.275 1.275 0 100-2.55 1.275 1.275 0 000 2.55z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.493 13.452h-1.615a.469.469 0 00-.467.468c0 .257.21.467.467.467h1.615c.257 0 .467-.21.467-.467a.469.469 0 00-.467-.468zM26.136 13.452H24.52a.469.469 0 00-.468.468c0 .257.21.467.468.467h1.614c.258 0 .468-.21.468-.467a.469.469 0 00-.468-.468z",
    fill: "#EBC21C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.963 28.017h-1.68a.591.591 0 00-.59.59c0 .324.266.59.59.59h1.68c.324 0 .59-.266.59-.59a.591.591 0 00-.59-.59zM20.596 28.017h-1.68a.591.591 0 00-.589.59c0 .324.265.59.59.59h1.68c.323 0 .589-.266.589-.59a.591.591 0 00-.59-.59zM24.23 28.017h-1.68a.591.591 0 00-.59.59c0 .324.266.59.59.59h1.68c.324 0 .59-.266.59-.59a.591.591 0 00-.59-.59zM16.963 26.328h-1.68a.591.591 0 00-.59.59c0 .324.266.59.59.59h1.68c.324 0 .59-.266.59-.59a.591.591 0 00-.59-.59zM20.596 26.328h-1.68a.591.591 0 00-.589.59c0 .324.265.59.59.59h1.68c.323 0 .589-.266.589-.59a.591.591 0 00-.59-.59zM22.55 27.507h1.68c.324 0 .59-.265.59-.59a.591.591 0 00-.59-.59h-1.68a.591.591 0 00-.59.59c0 .325.266.59.59.59z",
    fill: "#E2850E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.26 13.595l.002-.014h-.004a.325.325 0 00-.324-.31.325.325 0 00-.324.31h-.002c0 1.172-.943 2.126-2.101 2.126-1.159 0-2.101-.954-2.101-2.126h-.003a.325.325 0 00-.324-.31.326.326 0 00-.324.31h-.003v.017l.001.005c.012 1.523 1.242 2.758 2.754 2.758 1.511 0 2.742-1.235 2.753-2.758l.002-.005-.001-.003zM20.678 20.438c-.824-.223-1.171.4-1.171.4s-.347-.623-1.17-.4c-.825.222-.87.98-.713 1.358.155.379 1.046 1.27 1.314 1.514l.402.37c.167.154.145.17.358-.01.112-.096.245-.237.378-.36.268-.245 1.159-1.135 1.314-1.514.156-.379.112-1.136-.712-1.358z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.727 20.904a.094.094 0 00-.087-.093v-.002h-.005-.003l-.008.002a.715.715 0 00-.699.713.094.094 0 10.19 0h.002c0-.288.235-.523.523-.523v-.004a.094.094 0 00.087-.093z",
    fill: "#6B8FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "eva_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 1.2 -12.8 0 20 42.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eva_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgEva;